/* eslint-disable no-nested-ternary */
/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable no-await-in-loop */
/* eslint-disable no-loop-func */
/* eslint-disable no-param-reassign */
/* eslint-disable new-cap */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-restricted-syntax */
import React, {
  Fragment,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { IoClose, IoDownload, IoShareSocialSharp } from 'react-icons/io5';
import { FiEye } from 'react-icons/fi';
import { Form } from '@unform/web';
import { FormHandles } from '@unform/core';
import * as Yup from 'yup';
import Swal from 'sweetalert2';
import { QRCode } from 'react-qrcode-logo';
import { cpf } from 'cpf-cnpj-validator';

import { parseISO } from 'date-fns';
import { formatInTimeZone } from 'date-fns-tz';
import { BtnRevealQrCode, Circle, Container, Modal, ShareBox } from './styles';
import ButtonBack from '~/components/ButtonBack';
import Footer from '~/components/Footer';

import api from '~/services/api';
import { useAuth } from '~/hooks/Auth';
import InfiniteScroll from '~/components/InfiniteScroll';
import InputCheckbox from '~/components/InputCheckbox';
import Input from '~/components/Input';
import Select, { IOption } from '~/components/Select';
import InputMask from '~/components/InputMask';
import getValidationErros from '~/utils/getValidationsErrors';
import formatDate from '~/utils/formatDate';

import logo from '~/assets/logos/logo.png';
import logoQrcode from '~/assets/logos/logo-qrcode.svg';
import Toast from '~/utils/toast';
import { KrClose } from '~/components/KoroIcons';
import Question from '~/components/Question';
import InputRadio from '~/components/InputRadio';

interface IEvent {
  name: string;
  date: string;
  address: string;
  description: string;
}

interface ITicketData {
  id: number;
  user_id: number;
  code: number;
  document: string;
  email: string;
  name: string;
  status: string;
  modality?: {
    id: number;
    name: string;
  };
  batchCategory: {
    id: number;
    has_age_group?: boolean;
    min_age?: number;
    max_age?: number;
    has_kit?: boolean;
    batch: {
      event: {
        id: number;
        name: string;
        description: string;
        date: string;
        type: {
          name: string;
        };
        event: {
          date: string;
        };
        address: {
          zip_code: any;
          country: any;
          state: any;
          city: any;
          neighborhood: any;
          number: any;
          street: any;
          full_address: string;
        };
      };
    };
    category: {
      name: string;
      is_elderly?: boolean;
      is_child?: boolean;
      is_male?: boolean;
      is_female?: boolean;
    };
  };
  orderItem: {
    price: string;
    order: {
      status: string;
      code: number;
      courtesy_id?: number;
      payment: {
        qr_code?: string;
        payment_type?: string;
      };
      created_at: string;
      total: string;
    };
    event: {
      fill_before: number;
    };
  };
  kitUser?: {
    kit2Quantity: {
      size: string;
    };
    kit2_id: number;
    kitQuantity_id?: number;
    size: {
      size: string;
    };
    quantity: {
      size: string;
    };
  };
  archive?: {
    id: number;
    name: string;
    path: string;
    archive_url: string | null;
  } | null;
}

interface ITicketResponse {
  data: ITicketData[];
  from: number;
  to: number;
  total: number;
  pages: number;
}

interface ITicket {
  id: number;
  batch_category_id: number;
  modality_id?: number;
  event_id: number;
  user_id: number;
  orderCode: number;
  code: number;
  event: string;
  event_date: string;
  showMyTicket?: boolean;
  myTicket: boolean;
  reveled: boolean;
  name: string;
  phone?: string;
  email?: string;
  document: string;
  birthdate?: string;
  category: string;
  modality: string;
  address: string;
  status: string;
  fill_before?: number;
  price?: string;
  is_elderly?: boolean;
  is_child?: boolean;
  is_male?: boolean;
  is_female?: boolean;
  has_age_group?: boolean;
  min_age?: number;
  max_age?: number;
  has_kit?: boolean;
  kit?: {
    id: number;
    quantity_id?: number;
    quantity?: {
      size: string;
    };
  };
  pdf_url?: string | null;
}

interface IQuantities {
  id: number;
  size: string;
}

interface IEventResponse {
  id: number;
  fill_before: number;
  kit2: {
    id: number;
    has_size_variation: boolean;
    quantities: IQuantities[];
  };
}

interface IParams {
  slug: string;
}

interface IFormData {
  document: string;
  name: string;
  phone: string;
  email: string;
  documents: string;
  color: string;
  size: string;
  birthdate: string;
  gender: string;
}

interface IOrderData {
  status: string;
  paymentMethod: string;
  price: string;
  qrCode?: string;
  tickets: ITicket[];
  created_at: string;
}

interface IOrder {
  [key: string]: IOrderData;
}

export interface IAlternative {
  id: number;
  text: string;
}

export interface IQuestion {
  id: number;
  question: string;
  type: 'unique-choice' | 'multiple-choice' | 'free-text';
  alternatives?: IAlternative[];
  isRequired?: boolean;
}

interface IAlternativesResponse {
  id: number;
  name: string;
}

export interface IQuestionResponse {
  id: number;
  event_id: number;
  question_type_id: number;
  name: string;
  order: number;
  required: boolean;
  alternatives: IAlternativesResponse[];
}

interface IAnswer {
  event_id: number;
  question_type_id: number;
  question_id: number;
  alternative_id: number;
  text: string;
}

interface ICheckTicket {
  batch_category_id: number;
  modality_id: number;
  event: {
    unique_ticket: boolean;
  };
  batchCategory: {
    category_id: number;
    modality_id: number;
  };
}
interface ISize {
  id: number;
  value: string;
  selected: boolean;
  notSelectable?: boolean;
}

const Ticket: React.FC = () => {
  const { user, updateUser } = useAuth();
  const params = useParams<IParams>();
  const formRef = useRef<FormHandles>(null);
  const [showShare, setShowShare] = useState(false);
  const [shareTicket, setShareTicket] = useState<{
    orderCode: string;
    index: number;
    name: string;
  } | null>(null);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [loadingMore, setLoadingMore] = useState(false);
  const [orders, setOrders] = useState({} as IOrder);
  const [ticketsData, setTicketsData] = useState<ITicketData[]>([]);
  const [ticketSelected, setTicketSelected] = useState({} as ITicket);
  const [show, setShow] = useState(false);
  const [myTicket, setMyTicket] = useState(false);
  const [eventId, setEventId] = useState(0);
  const [event, setEvent] = useState({} as IEvent);
  const [ticketError, setTicketError] = useState('');
  const [orderSelected, setOrderSelected] = useState({} as IOrderData);
  const [showPix, setShowPix] = useState(false);
  const [sending, setSending] = useState(false);
  const [questions, setQuestions] = useState<IQuestion[]>([]);
  const [answers, setAnswers] = useState<IAnswer[]>([]);
  const [sizes, setSizes] = useState<ISize[]>([]);
  const [kitId, setKitId] = useState<number | undefined>(undefined);
  const [hasSizeVariation, setHasSizeVariation] = useState(false);
  const [genderSelected, setGenderSelected] = useState({} as IOption);
  const [fillBefore, setFillBefore] = useState(0);
  const location = useLocation();

  const timeZone = 'Etc/GMT';

  const genderOptions = useMemo<IOption[]>(
    () => [
      { id: 'M', value: 'Masculino', notSelectable: false, selected: false },
      { id: 'F', value: 'Feminino', notSelectable: false, selected: false },
    ],
    []
  );

  useEffect(() => {
    if (eventId) {
      api
        .get<IQuestionResponse[]>(`questions/events/${eventId}`)
        .then((response) => {
          const data = response.data.map<IQuestion>((question) => {
            let type = 'free-text';

            if (question.question_type_id === 2) {
              type = 'unique-choice';
            }

            if (question.question_type_id === 3) {
              type = 'multiple-choice';
            }

            const alternatives = question.alternatives.map((alternative) => ({
              id: alternative.id,
              text: alternative.name,
              new: false,
            }));

            return {
              id: question.id,
              question: question.name,
              type: type as IQuestion['type'],
              order: question.order,
              alternatives,
              isRequired: question.required,
            };
          });
          setQuestions(data);
        });
    }
  }, [eventId]);

  useEffect(() => {
    api
      .get<IEventResponse>(`events/${params.slug}`, {
        params: {
          enviroment: 'atleta',
        },
      })
      .then((response) => {
        if (response.data.kit2) {
          if (response.data.kit2.has_size_variation) {
            const sizesData = response.data.kit2.quantities.map((quantity) => ({
              id: quantity.id,
              value: quantity.size.replaceAll('_BABY', ' BABYLOOK'),
              selected: false,
              notSelectable: false,
            }));
            setSizes(sizesData);
          }
          setHasSizeVariation(response.data.kit2.has_size_variation);
          setKitId(response.data.kit2.id);
        }
        setFillBefore(response.data.fill_before);
        setEventId(response.data.id);
      });
  }, [params.slug]);

  useEffect(() => {
    const groupedByOrderCode = ticketsData.reduce((acc, ticket) => {
      const { address } = ticket.batchCategory.batch.event;
      const orderCode = ticket.orderItem.order.code;
      if (acc[orderCode] && acc[orderCode].tickets) {
        acc[orderCode].tickets.push({
          id: ticket.id,
          batch_category_id: ticket.batchCategory.id,
          modality_id: ticket.modality?.id,
          event_id: ticket.batchCategory.batch.event.id,
          user_id: ticket.user_id,
          orderCode,
          price: ticket.orderItem.order.total,
          code: ticket.code,
          email: ticket.email || '',
          event: ticket.batchCategory.batch.event.name,
          event_date: ticket.batchCategory.batch.event.date,
          showMyTicket: true,
          myTicket:
            (user.additionalInformation.document &&
              ticket.document === user.additionalInformation.document) ||
            false,
          reveled: !!ticket.document,
          name:
            fillBefore === 2 ? 'Não necessita' : ticket.name || 'Não informado',
          document: fillBefore === 2 ? 'Não necessita' : ticket.document || '',
          category: ticket.batchCategory.category.name,
          is_elderly: ticket.batchCategory.category.is_elderly,
          is_child: ticket.batchCategory.category.is_child,
          is_male: ticket.batchCategory.category.is_male,
          is_female: ticket.batchCategory.category.is_female,
          has_age_group: ticket.batchCategory.has_age_group,
          min_age: ticket.batchCategory.min_age,
          max_age: ticket.batchCategory.max_age,
          has_kit: ticket.batchCategory.has_kit,
          modality: ticket.modality?.name || '-',
          address: `${address.full_address}`,
          status: ticket.status,
          fill_before: fillBefore,
          pdf_url: ticket.archive?.archive_url,
          kit: ticket.kitUser
            ? {
                id: ticket.kitUser.kit2_id,
                quantity_id: ticket.kitUser.kitQuantity_id,
                quantity: {
                  size:
                    ticket.kitUser.size?.size ||
                    ticket.kitUser.kit2Quantity.size.replace(
                      '_BABY',
                      ' BABYLOOK'
                    ),
                },
              }
            : undefined,
        });
      } else {
        acc[orderCode] = {
          status: ticket.orderItem.order.status,
          paymentMethod:
            ticket.orderItem.order.courtesy_id &&
            !ticket.orderItem.order.payment?.payment_type
              ? 'Cortesia'
              : ticket.orderItem.order.payment?.payment_type ===
                  'credit-card' ||
                ticket.orderItem.order.payment?.payment_type === 'credit_card'
              ? 'Cartão de crédito'
              : 'PIX',
          qrCode: ticket.orderItem.order.payment?.qr_code,
          price: ticket.orderItem.order.total,
          tickets: [
            {
              id: ticket.id,
              batch_category_id: ticket.batchCategory.id,
              modality_id: ticket.modality?.id,
              event_id: ticket.batchCategory.batch.event.id,
              user_id: ticket.user_id,
              orderCode,
              code: ticket.code,
              event: ticket.batchCategory.batch.event.name,
              event_date: ticket.batchCategory.batch.event.date,
              showMyTicket: true,

              myTicket:
                (user.additionalInformation.document &&
                  ticket.document === user.additionalInformation.document) ||
                false,
              reveled: !!ticket.document,
              name:
                fillBefore === 2
                  ? 'Não necessita'
                  : ticket.name || 'Não informado',
              document:
                fillBefore === 2 ? 'Não necessita' : ticket.document || '',
              email: fillBefore === 2 ? 'Não necessita' : ticket.email || '',
              category: ticket.batchCategory.category.name,
              is_elderly: ticket.batchCategory.category.is_elderly,
              is_child: ticket.batchCategory.category.is_child,
              is_male: ticket.batchCategory.category.is_male,
              is_female: ticket.batchCategory.category.is_female,
              has_age_group: ticket.batchCategory.has_age_group,
              min_age: ticket.batchCategory.min_age,
              max_age: ticket.batchCategory.max_age,
              has_kit: ticket.batchCategory.has_kit,
              modality: ticket.modality?.name || '-',
              address: `${address.full_address}`,
              status: ticket.status,
              fill_before: fillBefore,
              pdf_url: ticket.archive?.archive_url,
              kit: ticket.kitUser
                ? {
                    id: ticket.kitUser.kit2_id,
                    quantity_id: ticket.kitUser.kitQuantity_id,
                    quantity: {
                      size:
                        ticket.kitUser.size?.size ||
                        ticket.kitUser.kit2Quantity?.size.replace(
                          '_BABY',
                          ' BABYLOOK'
                        ),
                    },
                  }
                : undefined,
            },
          ],
          created_at: formatInTimeZone(
            parseISO(ticket.orderItem.order.created_at),
            timeZone,
            'dd/MM/yyyy - HH:mm'
          ),
        };
      }
      return acc;
    }, {} as IOrder);

    setOrders(groupedByOrderCode);
  }, [event, fillBefore, ticketsData, user.additionalInformation.document]);

  const handleLoadTickets = useCallback(
    async (pageData) => {
      try {
        setTicketError('');
        const response = await api.get<ITicketResponse>(
          `tickets/users/${params.slug}`,
          {
            params: {
              page: pageData,
            },
          }
        );

        setEvent({
          name: response.data.data[0].batchCategory.batch.event.name,
          description:
            response.data.data[0].batchCategory.batch.event.description,
          date: formatInTimeZone(
            parseISO(response.data.data[0].batchCategory.batch.event.date),
            'Europe/London',
            'dd/MM/yyyy'
          ),
          address: response.data.data[0].batchCategory.batch.event.address
            .full_address
            ? `${response.data.data[0].batchCategory.batch.event.address.full_address}`
            : `${response.data.data[0].batchCategory.batch.event.address.street}, ${response.data.data[0].batchCategory.batch.event.address.number} - ${response.data.data[0].batchCategory.batch.event.address.neighborhood}, ${response.data.data[0].batchCategory.batch.event.address.city}/${response.data.data[0].batchCategory.batch.event.address.state}, ${response.data.data[0].batchCategory.batch.event.address.zip_code}, ${response.data.data[0].batchCategory.batch.event.address.country}`,
        });

        if (pageData === 1) {
          setTicketsData(response.data.data);
        } else {
          setTicketsData((state) => [...state, ...response.data.data]);
        }
        setTotalPages(response.data.pages);
      } catch (error) {
        console.log(error);
      } finally {
        setLoadingMore(false);
      }
    },
    [params.slug]
  );

  useEffect(() => {
    handleLoadTickets(1);
  }, [handleLoadTickets]);

  const blobToBase64RN = useCallback(async (blob: Blob) => {
    const arrayBuffer = await blob.arrayBuffer();
    return Buffer.from(arrayBuffer).toString('base64');
  }, []);

  const handleSaveAsPDF = useCallback(
    async (
      orderCode: string,
      index: number,
      name: string,
      downloadOnly = false
    ) => {
      const newOrders = { ...orders };
      if (
        newOrders[orderCode].status === 'Pago' ||
        newOrders[orderCode].status === 'Devolução Parcial' ||
        newOrders[orderCode].status === 'Cortesia'
      ) {
        if (newOrders[orderCode].tickets[index].document === '') {
          setTicketSelected(newOrders[orderCode].tickets[index]);
          setShow(true);

          const tickets = Object.values(newOrders).reduce(
            (acc, order) => [...acc, ...order.tickets],
            [] as ITicket[]
          );

          const reveledTickets = tickets.filter((ticket) => ticket.reveled);

          const showMyTicket = !reveledTickets.some(
            (ticket) =>
              ticket.myTicket &&
              newOrders[orderCode].tickets[index].batch_category_id ===
                ticket.batch_category_id &&
              newOrders[orderCode].tickets[index].modality_id ===
                ticket.modality_id
          );

          newOrders[orderCode].tickets[index].showMyTicket = showMyTicket;
        } else {
          const ticketData = newOrders[orderCode].tickets[index];

          const fileName = `Ingresso-de-${
            name === 'Não necessita'
              ? event.name.toLowerCase().replace(/ /g, '-')
              : name.toLowerCase().replace(/ /g, '-')
          }.pdf`;

          let blob: Blob;
          if (ticketData.pdf_url) {
            const fetchResponse = await fetch(ticketData.pdf_url);
            blob = await fetchResponse.blob();
          } else {
            const generateResponse = await api.get(
              `tickets/${ticketData.id}/pdf`,
              { responseType: 'blob' }
            );
            blob = new Blob([generateResponse.data], {
              type: 'application/pdf',
            });
          }

          if (window.ReactNativeWebView) {
            const base64 = await blobToBase64RN(blob);
            window.ReactNativeWebView.postMessage(
              JSON.stringify({ base64, fileName })
            );
          } else {
            const file = new File([blob], fileName, {
              type: 'application/pdf',
            });
            const nav = navigator as any;
            if (
              !downloadOnly &&
              nav.canShare &&
              nav.canShare({ files: [file] })
            ) {
              await nav.share({ files: [file], title: fileName });
            } else {
              const blobUrl = URL.createObjectURL(blob);
              const link = document.createElement('a');
              link.href = blobUrl;
              link.download = fileName;
              link.click();
              URL.revokeObjectURL(blobUrl);
            }
          }
        }
      }
    },
    [blobToBase64RN, event.name, orders]
  );

  const handleOpenShare = useCallback(
    (orderCode: string, index: number, name: string) => {
      setShareTicket({ orderCode, index, name });
      setShowShare(true);
    },
    []
  );

  const handleShareNative = useCallback(async () => {
    if (!shareTicket) return;
    await handleSaveAsPDF(
      shareTicket.orderCode,
      shareTicket.index,
      shareTicket.name,
      false
    );
  }, [handleSaveAsPDF, shareTicket]);

  const handleDownloadOnly = useCallback(async () => {
    if (!shareTicket) return;
    await handleSaveAsPDF(
      shareTicket.orderCode,
      shareTicket.index,
      shareTicket.name,
      true
    );
  }, [handleSaveAsPDF, shareTicket]);

  const handleLoad = useCallback(async () => {
    if (!loadingMore) {
      setLoadingMore(true);
      if (page < totalPages) {
        await handleLoadTickets(page + 1);
        setPage(page + 1);
      } else {
        setLoadingMore(false);
      }
    }
  }, [handleLoadTickets, loadingMore, page, totalPages]);

  const handleClickRevealQrCode = useCallback(
    (orderCode, ticketIndex) => {
      const newOrders = { ...orders };
      if (
        newOrders[orderCode].status === 'Pago' ||
        newOrders[orderCode].status === 'Devolução Parcial' ||
        newOrders[orderCode].status === 'Cortesia'
      ) {
        if (newOrders[orderCode].tickets[ticketIndex].document === '') {
          const tickets = Object.values(newOrders).reduce(
            (acc, order) => [...acc, ...order.tickets],
            [] as ITicket[]
          );

          const reveledTickets = tickets.filter((ticket) => ticket.reveled);

          const showMyTicket = !reveledTickets.some(
            (ticket) =>
              ticket.myTicket &&
              newOrders[orderCode].tickets[ticketIndex].batch_category_id ===
                ticket.batch_category_id &&
              newOrders[orderCode].tickets[ticketIndex].modality_id ===
                ticket.modality_id
          );

          newOrders[orderCode].tickets[ticketIndex].showMyTicket = showMyTicket;
          setTicketSelected(newOrders[orderCode].tickets[ticketIndex]);
          setShow(true);
        } else {
          newOrders[orderCode].tickets[ticketIndex].reveled = true;
        }
      }
      setOrders(newOrders);
    },
    [orders]
  );

  const handleClose = useCallback(() => {
    setTicketError('');
    setTicketSelected({} as ITicket);
    setShow(false);
    setMyTicket(false);
  }, []);

  const handleSubmit = useCallback(
    async (data: IFormData) => {
      const calculateAge = (
        birthdateStr: string,
        referenceDateStr?: string
      ): number | null => {
        if (!birthdateStr) return null;
        let birth: Date;
        if (
          birthdateStr.includes('T') ||
          /^\d{4}-\d{2}-\d{2}/.test(birthdateStr)
        ) {
          const d = new Date(birthdateStr);
          if (Number.isNaN(d.getTime())) return null;
          birth = new Date(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
        } else {
          const parts = birthdateStr.split('/');
          if (parts.length !== 3) return null;
          const [day, month, year] = parts;
          birth = new Date(
            parseInt(year, 10),
            parseInt(month, 10) - 1,
            parseInt(day, 10)
          );
        }
        if (Number.isNaN(birth.getTime())) return null;
        let ref: Date;
        if (referenceDateStr) {
          const d = new Date(referenceDateStr);
          if (Number.isNaN(d.getTime())) return null;
          ref = new Date(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
        } else {
          ref = new Date();
        }
        let age = ref.getFullYear() - birth.getFullYear();
        const m = ref.getMonth() - birth.getMonth();
        if (m < 0 || (m === 0 && ref.getDate() < birth.getDate())) age -= 1;
        return age;
      };

      try {
        setSending(true);
        formRef.current?.setErrors({});

        if (!myTicket) {
          const schema = Yup.object().shape({
            document: Yup.string()
              .test('cpf', 'CPF inválido', (value) =>
                cpf.isValid(value as string)
              )
              .required('O CPF é obrigatório')
              .test(
                'check-no-duplicate-documents',
                'Este documento já foi usado em outro ingresso com esta categoria e modalidade',
                async (value, context) => {
                  const response = await api.get<ICheckTicket[]>(
                    `tickets/events/${eventId}/${value}`
                  );

                  if (response.data.length === 0) return true;

                  const { unique_ticket } = response.data[0].event;

                  if (unique_ticket) {
                    return context.createError({
                      message: 'Este documento já foi usado neste evento',
                    });
                  }

                  const checkTicket = response.data.some(
                    (ticketData) =>
                      ticketData.batch_category_id ===
                        ticketSelected.batch_category_id &&
                      ticketData.modality_id === ticketSelected.modality_id
                  );

                  return !checkTicket;
                }
              ),
            name: Yup.string()
              .required('O nome é obrigatório')
              .test('full-name', 'Informe nome e sobrenome', (value) => {
                if (!value) return false;

                const parts = value.trim().split(/\s+/).filter(Boolean);

                return parts.length >= 2;
              }),
            birthdate: Yup.string()
              .required('A data de nascimento é obrigatória')
              .test('check_age_restrictions', '', (value, context) => {
                const age = calculateAge(
                  data.birthdate,
                  ticketSelected.event_date
                );

                if (ticketSelected.has_age_group) {
                  const belowMin =
                    ticketSelected.min_age !== undefined &&
                    (age === null || age < ticketSelected.min_age);
                  const aboveMax =
                    ticketSelected.max_age !== undefined &&
                    (age === null || age > ticketSelected.max_age);

                  if (belowMin || aboveMax) {
                    let message =
                      'Esta categoria não permite a idade informada na data do evento';

                    if (
                      ticketSelected.min_age !== undefined &&
                      ticketSelected.max_age !== undefined
                    ) {
                      message = `Esta categoria é exclusiva para pessoas de ${ticketSelected.min_age} até ${ticketSelected.max_age} anos na data do evento`;
                    } else if (ticketSelected.min_age !== undefined) {
                      message = `Esta categoria é exclusiva para pessoas a partir de ${ticketSelected.min_age} anos na data do evento`;
                    } else if (ticketSelected.max_age !== undefined) {
                      message = `Esta categoria é exclusiva para pessoas com até ${ticketSelected.max_age} anos na data do evento`;
                    }

                    return context.createError({ message });
                  }

                  return true;
                }

                if (ticketSelected.is_child && ticketSelected.is_elderly) {
                  const childMaxAge = ticketSelected.max_age ?? 12;
                  const isElderlyValid = age !== null && age >= 60;
                  const isChildValid =
                    age !== null &&
                    (ticketSelected.min_age === undefined ||
                      age >= ticketSelected.min_age) &&
                    age <= childMaxAge;

                  if (!isElderlyValid && !isChildValid) {
                    const isTeen = childMaxAge > 12 && childMaxAge < 18;
                    const childNoun = isTeen ? 'adolescente' : 'criança';
                    const childText =
                      ticketSelected.min_age !== undefined
                        ? `${childNoun}s de ${ticketSelected.min_age} até ${childMaxAge} anos`
                        : `${childNoun} até ${childMaxAge} anos`;

                    return context.createError({
                      message: `Esta categoria é exclusiva para idoso 60+ ou ${childText} na data do evento`,
                    });
                  }

                  return true;
                }

                if (ticketSelected.is_child) {
                  const maxAge = ticketSelected.max_age ?? 12;
                  const isValid =
                    age !== null &&
                    (ticketSelected.min_age === undefined ||
                      age >= ticketSelected.min_age) &&
                    age <= maxAge;

                  if (!isValid) {
                    const isTeen = maxAge > 12 && maxAge < 18;
                    const childNoun = isTeen ? 'adolescente' : 'criança';
                    const message = ticketSelected.min_age
                      ? `Esta categoria é exclusiva para ${childNoun}s de ${ticketSelected.min_age} até ${maxAge} anos na data do evento`
                      : `Esta categoria é exclusiva para ${childNoun}s com até ${maxAge} anos na data do evento`;

                    return context.createError({ message });
                  }

                  return true;
                }

                if (ticketSelected.is_elderly) {
                  if (age === null || age < 60) {
                    return context.createError({
                      message:
                        'Esta categoria é exclusiva para pessoas com 60 anos ou mais na data do evento',
                    });
                  }

                  return true;
                }

                return true;
              }),
            gender: Yup.string()
              .required('O gênero é obrigatório')
              .test(
                'check_male',
                'Esta categoria é exclusiva para o sexo masculino',
                () => {
                  if (!ticketSelected.is_male) return true;
                  return data.gender === 'M';
                }
              )
              .test(
                'check_female',
                'Esta categoria é exclusiva para o sexo feminino',
                () => {
                  if (!ticketSelected.is_female) return true;
                  return data.gender === 'F';
                }
              ),
            phone: Yup.string().required('O telefone é obrigatório'),
            email: Yup.string().email().required('O e-mail é obrigatório'),
            color: Yup.string().when(`$checkColor`, {
              is: (checkColor: boolean) => checkColor,
              then: Yup.string().required('A cor é obrigatória'),
              otherwise: Yup.string(),
            }),
            size: Yup.string().test(
              'check_size',
              'O tamanho é obrigatório',
              () => {
                return ticketSelected.has_kit && hasSizeVariation
                  ? !!data.size
                  : true;
              }
            ),
            ...questions.reduce((previous, question) => {
              if (question.isRequired) {
                if (question.type === 'free-text') {
                  previous[`answer-text-${question.id}`] = Yup.string().when(
                    `$checkText-${question.id}`,
                    {
                      is: (checkText: boolean) => checkText,
                      then: Yup.string().required('A resposta é obrigatória'),
                      otherwise: Yup.string(),
                    }
                  );
                }
                if (question.type === 'unique-choice') {
                  previous[`answer-radio-${question.id}`] = Yup.string().when(
                    `$checkRadio-${question.id}`,
                    {
                      is: (checkRadio: boolean) => checkRadio,
                      then: Yup.string().required('A resposta é obrigatória'),
                      otherwise: Yup.string(),
                    }
                  );
                }
                if (question.type === 'multiple-choice') {
                  previous[`answer-multiple-${question.id}`] =
                    Yup.string().when(`$checkMultiple-${question.id}`, {
                      is: (checkMultiple: boolean) => checkMultiple,
                      then: Yup.string().required('A resposta é obrigatória'),
                      otherwise: Yup.string(),
                    });
                }
              }

              return previous;
            }, {} as { [key: string]: Yup.StringSchema<string | undefined, Record<string, any>, string | undefined> }),
          });

          await schema.validate(data, {
            abortEarly: false,
            context: {
              ...questions.reduce((previous, question) => {
                if (question.isRequired) {
                  if (question.type === 'free-text') {
                    previous[`checkText-${question.id}`] = question.isRequired;
                  }
                  if (question.type === 'unique-choice') {
                    previous[`checkRadio-${question.id}`] = question.isRequired;
                  }
                  if (question.type === 'multiple-choice') {
                    previous[`checkMultiple-${question.id}`] =
                      question.isRequired;
                  }
                }

                return previous;
              }, {} as { [key: string]: boolean }),
            },
          });
        } else {
          const schema = Yup.object().shape({
            myTicket: Yup.string()
              .test(
                'check-no-duplicate-documents',
                'Seu documento já foi usado em outro ingresso com esta categoria e modalidade.',
                async (_, context) => {
                  const response = await api.get<ICheckTicket[]>(
                    `tickets/events/${eventId}/${user.additionalInformation.document}`
                  );

                  if (response.data.length === 0) return true;

                  const { unique_ticket } = response.data[0].event;

                  if (unique_ticket) {
                    return context.createError({
                      message: 'Seu documento já foi usado para este evento.',
                    });
                  }

                  const checkTicket = response.data.some(
                    (ticketData) =>
                      ticketData.batch_category_id ===
                        ticketSelected.batch_category_id &&
                      ticketData.modality_id === ticketSelected.modality_id
                  );

                  return !checkTicket;
                }
              )
              .test('check_age_restrictions', '', (value, context) => {
                const { birthdate } = user.additionalInformation;
                const age = birthdate
                  ? calculateAge(birthdate, ticketSelected.event_date)
                  : null;

                if (ticketSelected.has_age_group) {
                  const belowMin =
                    ticketSelected.min_age !== undefined &&
                    (age === null || age < ticketSelected.min_age);
                  const aboveMax =
                    ticketSelected.max_age !== undefined &&
                    (age === null || age > ticketSelected.max_age);

                  if (belowMin || aboveMax) {
                    let message =
                      'Esta categoria não permite a idade informada na data do evento';

                    if (
                      ticketSelected.min_age !== undefined &&
                      ticketSelected.max_age !== undefined
                    ) {
                      message = `Esta categoria é exclusiva para pessoas de ${ticketSelected.min_age} até ${ticketSelected.max_age} anos na data do evento`;
                    } else if (ticketSelected.min_age !== undefined) {
                      message = `Esta categoria é exclusiva para pessoas a partir de ${ticketSelected.min_age} anos na data do evento`;
                    } else if (ticketSelected.max_age !== undefined) {
                      message = `Esta categoria é exclusiva para pessoas com até ${ticketSelected.max_age} anos na data do evento`;
                    }

                    return context.createError({ message });
                  }

                  return true;
                }

                if (ticketSelected.is_child && ticketSelected.is_elderly) {
                  const childMaxAge = ticketSelected.max_age ?? 12;
                  const isElderlyValid = age !== null && age >= 60;
                  const isChildValid =
                    age !== null &&
                    (ticketSelected.min_age === undefined ||
                      age >= ticketSelected.min_age) &&
                    age <= childMaxAge;

                  if (!isElderlyValid && !isChildValid) {
                    const isTeen = childMaxAge > 12 && childMaxAge < 18;
                    const childNoun = isTeen ? 'adolescente' : 'criança';
                    const childText =
                      ticketSelected.min_age !== undefined
                        ? `${childNoun}s de ${ticketSelected.min_age} até ${childMaxAge} anos`
                        : `${childNoun} até ${childMaxAge} anos`;

                    return context.createError({
                      message: `Esta categoria é exclusiva para idoso 60+ ou ${childText} na data do evento`,
                    });
                  }

                  return true;
                }

                if (ticketSelected.is_child) {
                  const maxAge = ticketSelected.max_age ?? 12;
                  const isValid =
                    age !== null &&
                    (ticketSelected.min_age === undefined ||
                      age >= ticketSelected.min_age) &&
                    age <= maxAge;

                  if (!isValid) {
                    const isTeen = maxAge > 12 && maxAge < 18;
                    const childNoun = isTeen ? 'adolescente' : 'criança';
                    const message =
                      ticketSelected.min_age !== undefined
                        ? `Esta categoria é exclusiva para ${childNoun}s de ${ticketSelected.min_age} até ${maxAge} anos na data do evento`
                        : `Esta categoria é exclusiva para ${childNoun}s com até ${maxAge} anos na data do evento`;

                    return context.createError({ message });
                  }

                  return true;
                }

                if (ticketSelected.is_elderly) {
                  if (age === null || age < 60) {
                    return context.createError({
                      message:
                        'Esta categoria é exclusiva para pessoas com 60 anos ou mais na data do evento',
                    });
                  }

                  return true;
                }

                return true;
              })
              .test(
                'check_male',
                'Esta categoria é exclusiva para o sexo masculino',
                () => {
                  if (!ticketSelected.is_male) return true;
                  return user.additionalInformation.gender === 'M';
                }
              )
              .test(
                'check_female',
                'Esta categoria é exclusiva para o sexo feminino',
                () => {
                  if (!ticketSelected.is_female) return true;
                  return user.additionalInformation.gender === 'F';
                }
              ),
            color: Yup.string().when(`$checkColor`, {
              is: (checkColor: boolean) => checkColor,
              then: Yup.string().required('A cor é obrigatória'),
              otherwise: Yup.string(),
            }),
            size: Yup.string().test(
              'check_size',
              'O tamanho é obrigatório',
              () => {
                return ticketSelected.has_kit && hasSizeVariation
                  ? !!data.size
                  : true;
              }
            ),
            ...questions.reduce((previous, question) => {
              if (question.isRequired) {
                if (question.type === 'free-text') {
                  previous[`answer-text-${question.id}`] = Yup.string().when(
                    `$checkText-${question.id}`,
                    {
                      is: (checkText: boolean) => checkText,
                      then: Yup.string().required('A resposta é obrigatória'),
                      otherwise: Yup.string(),
                    }
                  );
                }
                if (question.type === 'unique-choice') {
                  previous[`answer-radio-${question.id}`] = Yup.string().when(
                    `$checkRadio-${question.id}`,
                    {
                      is: (checkRadio: boolean) => checkRadio,
                      then: Yup.string().required('A resposta é obrigatória'),
                      otherwise: Yup.string(),
                    }
                  );
                }
                if (question.type === 'multiple-choice') {
                  previous[`answer-multiple-${question.id}`] =
                    Yup.string().when(`$checkMultiple-${question.id}`, {
                      is: (checkMultiple: boolean) => checkMultiple,
                      then: Yup.string().required('A resposta é obrigatória'),
                      otherwise: Yup.string(),
                    });
                }
              }

              return previous;
            }, {} as { [key: string]: Yup.StringSchema<string | undefined, Record<string, any>, string | undefined> }),
          });

          await schema.validate(data, {
            abortEarly: false,
            context: {
              ...questions.reduce((previous, question) => {
                if (question.isRequired) {
                  if (question.type === 'free-text') {
                    previous[`checkText-${question.id}`] = question.isRequired;
                  }
                  if (question.type === 'unique-choice') {
                    previous[`checkRadio-${question.id}`] = question.isRequired;
                  }
                  if (question.type === 'multiple-choice') {
                    previous[`checkMultiple-${question.id}`] =
                      question.isRequired;
                  }
                }

                return previous;
              }, {} as { [key: string]: boolean }),
            },
          });
        }

        const responseCheck = await api.get(
          `tickets/events/${ticketSelected.event_id}/${
            myTicket && user.additionalInformation.document
              ? user.additionalInformation.document
              : data.document
          }`
        );

        if (responseCheck.data.length > 0) {
          const hasDuplicateTicket = responseCheck.data.some(
            (ticketData: any) =>
              ticketData.batch_category_id ===
                ticketSelected.batch_category_id &&
              ticketData.modality_id === ticketSelected.modality_id
          );

          if (hasDuplicateTicket) {
            throw new Error('ingresso repetido');
          }
        }

        let date = '';
        let kit = '';
        if (data.size) {
          const kitSelected = sizes.find(
            (size) => size.id.toString() === data.size
          );
          kit = kitSelected ? kitSelected.value : '';
        }

        if (myTicket && user.additionalInformation.birthdate) {
          date = user.additionalInformation.birthdate;
        } else if (data.birthdate) {
          const [day, month, year] = data.birthdate.split('/');
          date = `${year}-${month}-${day}`;
        }

        const formData = {
          batch_category_id: ticketSelected.batch_category_id,
          modality_id: ticketSelected.modality_id,
          user_id: ticketSelected.user_id,
          document:
            myTicket && user.additionalInformation.document
              ? user.additionalInformation.document
              : data.document,
          name: myTicket ? user.name : data.name,
          email: myTicket ? user.email : data.email,
          phone:
            myTicket && user.additionalInformation.phone
              ? user.additionalInformation.phone
              : data.phone,
          gender:
            myTicket && user.additionalInformation.gender
              ? user.additionalInformation.gender
              : data.gender,
          birthdate: date,
          kit,
          status: ticketSelected.status === 'Disponível' ? 'Usado' : undefined,
        };

        const response = await api.put(
          `tickets/${ticketSelected.id}`,
          formData
        );

        if (answers.length > 0) {
          for (const answer of answers) {
            const formDataAnswer = {
              ticket_id: response.data.id,
              event_id: eventId,
              question_type_id: answer.question_type_id,
              question_id: answer.question_id,
              alternative_id: answer.alternative_id,
              text: answer.text,
            };

            await api.post('answers', formDataAnswer);
          }
        }

        if (ticketSelected.has_kit && kitId) {
          const kitUserFormData = {
            event_id: eventId,
            kit2_id: kitId,
            user_id: ticketSelected.user_id,
            ticket_id: ticketSelected.id,
            kitQuantity_id: data.size,
          };

          await api.post('kits-users', kitUserFormData);
        }

        if (myTicket) {
          const formDataTicket = {
            user_id: user.id,
            document: user.additionalInformation.document || data.document,
            phone: user.additionalInformation.phone || data.phone,
            gender: user.additionalInformation.gender || data.gender,
            birthdate: date,
          } as {
            user_id: number;
            document?: string;
            phone: string;
            gender: string;
            birthdate: string;
          };

          const checkDocument = await api.get(
            `additional-informations/document/${data.document}`
          );
          if (checkDocument.data.user_id === user.id) {
            delete formDataTicket.document;
          }

          await api.put(
            `additional-informations/${user.additionalInformation.id}`,
            formDataTicket
          );

          updateUser({
            ...user,
            additionalInformation: {
              ...user.additionalInformation,
              document: formDataTicket.document,
              phone: formDataTicket.phone,
              gender: formDataTicket.gender,
              birthdate: formDataTicket.birthdate,
            },
          });
        }

        const newOrders = { ...orders };
        const ticketIndex = newOrders[
          ticketSelected.orderCode
        ].tickets.findIndex((ticket) => ticket.id === ticketSelected.id);

        if (ticketIndex >= 0) {
          newOrders[ticketSelected.orderCode].tickets[ticketIndex].name =
            response.data.name;
          newOrders[ticketSelected.orderCode].tickets[
            ticketIndex
          ].document = `****${response.data.document.slice(4, 11)}***`;
          newOrders[ticketSelected.orderCode].tickets[ticketIndex].reveled =
            true;
          newOrders[ticketSelected.orderCode].tickets[ticketIndex].myTicket =
            myTicket;
          newOrders[ticketSelected.orderCode].tickets[ticketIndex].pdf_url =
            response.data.archive?.archive_url || null;
          if (ticketSelected.has_kit && kitId) {
            const kitSelected = sizes.find(
              (size) => size.id.toString() === data.size
            );
            newOrders[ticketSelected.orderCode].tickets[ticketIndex].kit = {
              id: kitId,
              quantity_id: data.size ? parseInt(data.size, 10) : undefined,
              quantity: kitSelected ? { size: kitSelected.value } : undefined,
            };
          }
        }

        Swal.fire({
          icon: 'success',
          iconColor: '#ff6900',
          title: `Esse ingresso foi atribuído para ${
            ticketSelected.name.split(' ')[0]
          }`,
          showCloseButton: true,
        }).finally(() => {
          window.location.reload();
        });
        setOrders(newOrders);
        handleClose();
        setSending(false);
      } catch (error) {
        setSending(false);
        const err = error as any;
        if (error instanceof Yup.ValidationError) {
          const errors = getValidationErros(error);
          formRef.current?.setErrors(errors);
        } else if (err.message === 'ingresso repetido') {
          setTicketError(
            data.document === user.additionalInformation.document
              ? 'Você já possui um ingresso para este evento'
              : 'Já existe um ingresso com este CPF para este evento'
          );
        } else {
          Swal.fire('Oops...', 'Ocorreu um erro tente novamente, por favor');
        }
      }
    },
    [
      myTicket,
      ticketSelected,
      user,
      answers,
      kitId,
      orders,
      handleClose,
      questions,
      eventId,
      hasSizeVariation,
      sizes,
      updateUser,
    ]
  );

  const handleChangeMyTicket = useCallback(() => {
    setTicketError('');
    setMyTicket((state) => !state);
  }, []);

  const handleChangeDocument = useCallback(
    async (e) => {
      const { value } = e.target;

      if (value.length === 14) {
        const response = await api.get(`tickets/document/${value}`);
        if (response.data.length > 0) {
          const selectedGender =
            genderOptions.find((opt) => opt.id === response.data[0].gender) ||
            ({} as IOption);
          setGenderSelected(selectedGender);
          setTicketSelected((oldState) => ({
            ...oldState,
            document: value,
            name: response.data[0].name,
            phone: response.data[0].phone,
            email: response.data[0].email,
            birthdate: response.data[0].birthdate
              ? formatDate(response.data[0].birthdate, 'dd/MM/yyyy')
              : '',
            gender: response.data[0].gender || '',
          }));
        } else {
          const responseAdditionalInformation = await api.get(
            `additional-informations/document/${value}`
          );
          if (responseAdditionalInformation.data) {
            const selectedGender =
              genderOptions.find(
                (opt) => opt.id === responseAdditionalInformation.data.gender
              ) || ({} as IOption);
            setGenderSelected(selectedGender);
            setTicketSelected((oldState) => ({
              ...oldState,
              document: value,
              name: responseAdditionalInformation.data.user.name,
              phone: responseAdditionalInformation.data.phone,
              email: responseAdditionalInformation.data.user.email,
              birthdate: responseAdditionalInformation.data.birthdate
                ? formatDate(
                    responseAdditionalInformation.data.birthdate,
                    'dd/MM/yyyy'
                  )
                : '',
              gender: responseAdditionalInformation.data.gender || '',
            }));
          }
        }
      }
    },
    [genderOptions]
  );

  const handleClickQrCode = useCallback((order) => {
    setOrderSelected(order);
    setShowPix(true);
  }, []);

  const handleClickCopyPix = useCallback(async () => {
    await navigator.clipboard.writeText(orderSelected.qrCode as string);
    Toast.fire({
      icon: 'success',
      iconColor: '#ff6900',
      title: 'Código copiado!',
    });
  }, [orderSelected]);

  const handleChangeAnswer = useCallback(
    (answer, questionId) => {
      const answerExist = answers.some(
        (answerData) => answerData.question_id === questionId
      );

      let dataAnswers: IAnswer[] = answers;
      if (answerExist) {
        dataAnswers = dataAnswers.filter(
          (answerData) => answerData.question_id !== questionId
        );

        dataAnswers.push(...answer);
      } else {
        dataAnswers.push(...answer);
      }
      setAnswers(dataAnswers);
    },
    [answers]
  );

  return (
    <Container>
      <InfiniteScroll onInfiniteLoad={handleLoad} className="infinite-scroll">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="bg-white event px-3 py-3 mt-3">
                <ButtonBack className="" />

                <h1 className="my-3">{event.name}</h1>
                <p className="mb-1">Data: {event.date}</p>
                <p className="mb-3">
                  Local: {event.address?.replace('n˚ 0', 'S/N')}
                </p>
              </div>
            </div>
            <div className="col-12">
              <h2 className="h5 text-black mt-3">Meus Ingressos</h2>
              {Object.entries(orders).map(([orderCode, order]) => (
                <>
                  {(location.pathname.includes('/meus-ingressos/proximos') ||
                    location.pathname.includes(
                      '/meus-ingressos/realizados'
                    )) && (
                    <>
                      {order.status !== 'Expirado' &&
                        order.status !== 'Cancelado' &&
                        order.status !== 'Devolvido' &&
                        !order.tickets.every(
                          (ticket) => ticket.status === 'Devolvido'
                        ) && (
                          <div key={orderCode} className="mt-3">
                            <h4 className="h6">Pedido #{orderCode}</h4>
                            <h4 className="h6">{order.created_at}</h4>
                            <div className="d-flex justify-content-between align-items-center">
                              <h4 className="h6">
                                {parseFloat(order.price) <= 0
                                  ? 'Reservado - Grátis'
                                  : `${order.status} - ${order.paymentMethod}`}
                              </h4>

                              {order.status === 'Aguardando pagamento' &&
                                order.paymentMethod === 'PIX' &&
                                order.qrCode && (
                                  <button
                                    type="button"
                                    className="btn btn-primary ms-2"
                                    onClick={() => handleClickQrCode(order)}
                                  >
                                    Ver QR code PIX
                                  </button>
                                )}
                            </div>

                            {order.tickets.map((ticket, index) => (
                              <>
                                {ticket.status !== 'Devolvido' && (
                                  <div
                                    key={ticket.id}
                                    className="position-relative"
                                  >
                                    <button
                                      onClick={() => {
                                        if (
                                          order.status ===
                                            'Aguardando pagamento' &&
                                          order.paymentMethod === 'PIX' &&
                                          order.qrCode
                                        ) {
                                          handleClickQrCode(order);
                                        } else {
                                          handleOpenShare(
                                            orderCode,
                                            index,
                                            ticket.name
                                          );
                                        }
                                      }}
                                      type="button"
                                      className="share border-0 bg-transparent"
                                      disabled={
                                        ticket.status === 'Cancelado' ||
                                        ticket.status === 'Expirado' ||
                                        ticket.status === 'Devolvido'
                                      }
                                    >
                                      <IoShareSocialSharp
                                        color="#00A3E0"
                                        size={24}
                                      />
                                    </button>

                                    {(ticket.status === 'Cancelado' ||
                                      ticket.status === 'Expirado') && (
                                      <span className="pending d-inline-block text-white bg-danger rounded-pill px-3 py-1">
                                        Ingresso cancelado
                                      </span>
                                    )}

                                    {ticket.status === 'Devolvido' && (
                                      <span className="pending d-inline-block text-white bg-danger rounded-pill px-3 py-1">
                                        Ingresso devolvido
                                      </span>
                                    )}
                                    {ticket.status !== 'Cancelado' &&
                                      ticket.status !== 'Expirado' &&
                                      ticket.status !== 'Devolvido' &&
                                      ticket.fill_before !== 2 &&
                                      ticket.name === 'Não informado' && (
                                        <span className="pending d-inline-block text-white bg-danger rounded-pill px-3 py-1">
                                          Nomeação pendente
                                        </span>
                                      )}

                                    <div
                                      key={ticket.id}
                                      id={`ticket-${ticket.code}`}
                                      className="bg-ticket position-relative mt-3 py-5"
                                    >
                                      <div className="line-upper-left" />
                                      <div className="line-upper-right" />
                                      <div className="line-lower-left" />
                                      <div className="bg-qr-orange" />
                                      <BtnRevealQrCode
                                        type="button"
                                        className="border-0 bg-transparent d-block mx-auto"
                                        onClick={() => {
                                          if (
                                            order.status ===
                                              'Aguardando pagamento' &&
                                            order.paymentMethod === 'PIX' &&
                                            order.qrCode
                                          ) {
                                            handleClickQrCode(order);
                                          } else {
                                            handleClickRevealQrCode(
                                              orderCode,
                                              index
                                            );
                                          }
                                        }}
                                        reveled={
                                          ticket.document !== '' &&
                                          ticket.status !== 'Devolvido' &&
                                          (order.status.toLowerCase() ===
                                            'cortesia' ||
                                            order.status.toLowerCase() ===
                                              'pago' ||
                                            order.status.toLowerCase() ===
                                              'devolução parcial')
                                        }
                                        disabled={
                                          ticket.status === 'Cancelado' ||
                                          ticket.status === 'Expirado' ||
                                          ticket.status === 'Devolvido'
                                        }
                                      >
                                        <div className="text-center p-3 index">
                                          <div className="bd-qrcode mt-5">
                                            <QRCode
                                              value={`Identificador: #${ticket.code};`}
                                              removeQrCodeBehindLogo
                                              logoImage={logo}
                                              logoPadding={5}
                                              size={250}
                                              ecLevel="H"
                                              // bgColor="transparent"
                                            />
                                          </div>
                                          <p className="mx-auto px-2 py-1 mb-0 mt-2 ident">
                                            Identificador <br />#{ticket.code}
                                          </p>
                                        </div>
                                        <div className="blur">
                                          <FiEye size={64} color="#000" />
                                        </div>
                                      </BtnRevealQrCode>

                                      <div className="d-flex justify-content-between align-items-start px-3 mt-3 mb-2">
                                        <h2 className="h5 mb-0">
                                          {ticket.event}
                                          <br />
                                          <span className="data">
                                            <span>Data do evento:</span>{' '}
                                            {formatInTimeZone(
                                              parseISO(ticket.event_date),
                                              'Europe/London',
                                              'dd/MM/yyyy'
                                            )}
                                          </span>
                                        </h2>

                                        {ticket.myTicket && (
                                          <span className="my-ticket px-2 py-1">
                                            Meu ingresso
                                          </span>
                                        )}
                                      </div>
                                      <div className="px-3 pb-3">
                                        <p className="mb-2">
                                          <span className="me-2">Nome: </span>
                                          {ticket.name}
                                        </p>
                                        <p className="mb-2">
                                          <span className="me-2">
                                            Documento:{' '}
                                          </span>
                                          {ticket.document &&
                                          ticket.document !== 'Não necessita'
                                            ? `****${ticket.document.slice(
                                                4,
                                                11
                                              )}***`
                                            : ticket.document ===
                                              'Não necessita'
                                            ? ticket.document
                                            : 'Não informado'}
                                        </p>
                                        <p className="mb-2">
                                          <span className="me-2">
                                            Modalidade:{' '}
                                          </span>
                                          {ticket.modality}
                                        </p>
                                        <p className="mb-2">
                                          <span className="me-2">
                                            Categoria:{' '}
                                          </span>
                                          {ticket.category}
                                        </p>
                                        {ticket.kit && (
                                          <p className="mb-2">
                                            <span className="me-2">
                                              Tamanho do kit:{' '}
                                            </span>
                                            {ticket?.kit?.quantity?.size ||
                                              'Não possui'}
                                          </p>
                                        )}

                                        <p className="mb-0">
                                          <span className="me-2">
                                            Endereço:{' '}
                                          </span>
                                          {event.address?.replace(
                                            'Nº 0',
                                            'S/N'
                                          )}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                )}
                              </>
                            ))}
                          </div>
                        )}
                    </>
                  )}
                  {location.pathname.includes('/meus-ingressos/cancelados') && (
                    <>
                      {(order.status === 'Expirado' ||
                        order.status === 'Cancelado' ||
                        order.status.toLowerCase().includes('devolução')) && (
                        <div key={orderCode} className="mt-3">
                          <h4 className="h6">Pedido #{orderCode}</h4>
                          <h4 className="h6">{order.created_at}</h4>
                          <div className="d-flex justify-content-between align-items-center">
                            <h4 className="h6">
                              {order.status} - {order.paymentMethod}
                            </h4>
                          </div>
                          {order.tickets.map((ticket, index) => (
                            <>
                              {(ticket.status === 'Devolvido' ||
                                ticket.status === 'Cancelado' ||
                                ticket.status === 'Expirado') && (
                                <div
                                  key={ticket.id}
                                  className="position-relative"
                                >
                                  {(ticket.status === 'Cancelado' ||
                                    ticket.status === 'Expirado') && (
                                    <span className="pending d-inline-block text-white bg-danger rounded-pill px-3 py-1">
                                      Ingresso cancelado
                                    </span>
                                  )}

                                  {ticket.status === 'Devolvido' && (
                                    <span className="pending d-inline-block text-white bg-danger rounded-pill px-3 py-1">
                                      Ingresso devolvido
                                    </span>
                                  )}

                                  <div
                                    key={ticket.id}
                                    id={`ticket-${ticket.code}`}
                                    className="bg-ticket position-relative mt-3 py-5"
                                  >
                                    <div className="line-upper-left" />
                                    <div className="line-upper-right" />
                                    <div className="line-lower-left" />
                                    <div className="bg-qr-orange" />
                                    <BtnRevealQrCode
                                      type="button"
                                      disabled
                                      className="border-0 bg-transparent d-block mx-auto"
                                      onClick={() => {
                                        if (
                                          order.status ===
                                            'Aguardando pagamento' &&
                                          order.paymentMethod === 'PIX' &&
                                          order.qrCode
                                        ) {
                                          handleClickQrCode(order);
                                        } else {
                                          handleClickRevealQrCode(
                                            orderCode,
                                            index
                                          );
                                        }
                                      }}
                                      reveled={
                                        ticket.document !== '' &&
                                        order.status === 'Pago' &&
                                        ticket.status !== 'Cancelado'
                                      }
                                    >
                                      <div className="text-center p-3 index">
                                        <div className="bd-qrcode mt-5">
                                          <QRCode
                                            value={`Identificador: #${ticket.code};`}
                                            removeQrCodeBehindLogo
                                            logoImage={logo}
                                            logoPadding={5}
                                            size={250}
                                            ecLevel="H"
                                          />
                                        </div>
                                        <p className="mx-auto px-2 py-1 mb-0 mt-2 ident">
                                          Identificador <br />#{ticket.code}
                                        </p>
                                      </div>
                                      <div className="blur">
                                        <FiEye size={64} color="#000" />
                                      </div>
                                    </BtnRevealQrCode>

                                    <div className="d-flex justify-content-between align-items-center px-3 mt-3 mb-2">
                                      <h2 className="h5 mb-0">
                                        {ticket.event}
                                        <br />
                                        <span className="data">
                                          <span>Data do evento:</span>{' '}
                                          {formatInTimeZone(
                                            parseISO(ticket.event_date),
                                            'Europe/London',
                                            'dd/MM/yyyy'
                                          )}
                                        </span>
                                      </h2>

                                      {ticket.myTicket && (
                                        <span className="my-ticket px-2 py-1">
                                          Meu ingresso
                                        </span>
                                      )}
                                    </div>
                                    <div className="px-3 pb-3">
                                      <p className="mb-2">
                                        <span className="me-2">Nome: </span>
                                        {ticket.name}
                                      </p>
                                      <p className="mb-2">
                                        <span className="me-2">
                                          Documento:{' '}
                                        </span>
                                        {ticket.document
                                          ? `****${ticket.document.slice(
                                              4,
                                              11
                                            )}***`
                                          : 'Não informado'}
                                      </p>
                                      <p className="mb-2">
                                        <span className="me-2">
                                          Modalidade:{' '}
                                        </span>
                                        {ticket.modality}
                                      </p>
                                      <p className="mb-2">
                                        <span className="me-2">
                                          Categoria:{' '}
                                        </span>
                                        {ticket.category}
                                      </p>

                                      <p className="mb-0">
                                        <span className="me-2">Endereço: </span>
                                        {event.address?.replace('Nº 0', 'S/N')}
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              )}
                            </>
                          ))}
                        </div>
                      )}
                    </>
                  )}
                </>
              ))}
            </div>
          </div>
        </div>
        <Footer />
      </InfiniteScroll>

      {showShare && (
        <button
          type="button"
          aria-label="Fechar"
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 999,
            background: 'rgba(0,0,0,0.4)',
            border: 'none',
            padding: 0,
          }}
          onClick={() => setShowShare(false)}
        />
      )}

      <ShareBox show={showShare}>
        <div className="d-flex justify-content-between align-items-center mb-3">
          <p className="fw-semibold mb-0" style={{ color: '#0f172a' }}>
            Compartilhar ingresso
          </p>
          <button
            type="button"
            className="border-0 bg-transparent p-0"
            onClick={() => setShowShare(false)}
            aria-label="Fechar"
          >
            <IoClose size={22} color="#64748b" />
          </button>
        </div>
        <div className="social-medias">
          <div className="d-flex justify-content-center gap-4">
            <div className="d-flex flex-column align-items-center gap-1">
              <button
                type="button"
                className="border-0 bg-transparent p-0"
                onClick={handleShareNative}
              >
                <Circle color="#00A3E0">
                  <IoShareSocialSharp size={24} color="#fff" />
                </Circle>
              </button>
              <small>Compartilhar</small>
            </div>
            <div className="d-flex flex-column align-items-center gap-1">
              <button
                type="button"
                className="border-0 bg-transparent p-0"
                onClick={handleDownloadOnly}
              >
                <Circle color="#FF6900">
                  <IoDownload size={24} color="#fff" />
                </Circle>
              </button>
              <small>Baixar</small>
            </div>
          </div>
        </div>
      </ShareBox>

      <Modal
        className="modal-filter"
        size="xl"
        centered
        show={show}
        onHide={handleClose}
      >
        <Form ref={formRef} onSubmit={handleSubmit}>
          <Modal.Header className="justify-content-between align-items-center border-0 px-3 px-sm-5 pb-0 pb-lg-4 pt-0">
            <Modal.Title className="mb-3 mt-4">
              <h2 className="title h5 fw-semibold mb-0">Dados do ingresso</h2>
            </Modal.Title>
            <button type="button" onClick={handleClose} className="border-0">
              <IoClose size={20} color="#989898" />
            </button>
          </Modal.Header>
          <Modal.Body className="pt-0 px-3 px-sm-5 mx-lg-4">
            <div className="mb-3">
              <h5 className="h6">
                <b>Modalidade:</b> {ticketSelected.modality}
              </h5>
              <h5 className="h6">
                <b>Categoria:</b> {ticketSelected.category}
              </h5>
            </div>
            {ticketSelected.showMyTicket && (
              <InputCheckbox
                type="checkbox"
                name="myTicket"
                className="my-3 d-block"
                options={[
                  {
                    label: 'Este ingresso é o meu',
                    value: 'Este ingresso é o meu',
                    selected: myTicket,
                  },
                ]}
                onChange={handleChangeMyTicket}
                error={ticketError}
              />
            )}
            {(!myTicket ||
              (myTicket && !user.additionalInformation.document)) && (
              <label className="mb-3">
                <span className="fw-normal d-block mb-2">Documento*</span>
                <div className="d-flex">
                  <Select
                    className="bd-input w-25"
                    name="documents"
                    readOnly
                    options={[
                      {
                        value: 'CPF',
                        id: 'CPF',
                        selected: true,
                      },
                    ]}
                  />
                  <div className="mt-0 ms-1 w-75">
                    <InputMask
                      kind="cpf"
                      name="document"
                      className="bd-input"
                      error={ticketError}
                      onChange={handleChangeDocument}
                    />
                  </div>
                </div>
              </label>
            )}
            {(!myTicket || (myTicket && !user.name)) && (
              <label className="mb-3 w-100">
                <span className="fw-normal d-block mb-2">Nome Completo*</span>
                <Input
                  name="name"
                  className="bd-input"
                  defaultValue={
                    ticketSelected.name !== 'Não informado'
                      ? ticketSelected.name
                      : undefined
                  }
                  onChange={(e) => {
                    e.target.value = e.target.value.replace(
                      /[^A-Za-zÀ-ÖØ-öø-ÿ\s]/g,
                      ''
                    );
                  }}
                />
              </label>
            )}
            {(!myTicket ||
              (myTicket && !user.additionalInformation.birthdate)) && (
              <label className="mb-3 w-100">
                <span className="fw-normal d-block mb-2">
                  Data de nascimento
                </span>
                <InputMask
                  kind="custom"
                  options={{ mask: '99/99/9999' }}
                  name="birthdate"
                  className="bd-input"
                  value={ticketSelected.birthdate}
                  inputMode="numeric"
                />
              </label>
            )}
            {(!myTicket ||
              (myTicket && !user.additionalInformation.gender)) && (
              <label className="mb-3 w-100">
                <span className="fw-normal d-block mb-2">Gênero</span>
                <InputRadio
                  name="gender"
                  className="d-flex justify-content-start check"
                  options={[
                    {
                      id: 'M',
                      value: 'Masculino',
                    },
                    {
                      id: 'F',
                      value: 'Feminino',
                    },
                  ]}
                  selected={genderSelected}
                  onChange={(e) => setGenderSelected(e as IOption)}
                />
              </label>
            )}
            {(!myTicket || (myTicket && !user.additionalInformation.phone)) && (
              <label className="mb-3 w-100">
                <span className="fw-normal d-block mb-2">Telefone*</span>
                <InputMask
                  kind="cel-phone"
                  name="phone"
                  className="bd-input"
                  value={ticketSelected.phone}
                />
              </label>
            )}
            {(!myTicket || (myTicket && !user.email)) && (
              <label className="mb-3 w-100">
                <span className="fw-normal d-block mb-2 size">E-mail*</span>
                <Input
                  type="email"
                  name="email"
                  className="bd-input"
                  defaultValue={ticketSelected.email}
                />
              </label>
            )}

            {ticketSelected.has_kit && sizes.length > 0 && (
              <label className="mb-3 w-100">
                <span className="fw-normal d-block mb-2">
                  Tamanho do(a) kit*
                </span>
                <Select
                  className="bd-input select-tam"
                  name="size"
                  options={sizes}
                />
              </label>
            )}
            {Object.keys(questions).length > 0 && (
              <div className="bg-information">
                <h2 className="h6">Mais informações</h2>
                {questions.map((question) => (
                  <Question
                    key={question.id}
                    question={question}
                    onChangeAnswer={(answer) => {
                      handleChangeAnswer(answer, question.id);
                    }}
                  />
                ))}
              </div>
            )}
          </Modal.Body>
          <Modal.Footer className="border-0 pb-4 px-3">
            <button
              type="submit"
              disabled={sending}
              className="w-100 mx-0 btn-filter d-flex align-items-center justify-content-center btn h6 fw-normal py-2 mt-2 mb-0 btn-login"
            >
              {sending ? 'Enviando...' : 'Enviar'}
            </button>
          </Modal.Footer>
        </Form>
      </Modal>
      <Modal show={showPix}>
        <Modal.Header className="d-flex align-items-center justify-content-center">
          <button
            type="button"
            onClick={() => setShowPix(false)}
            className="close-btn"
          >
            <KrClose size={20} color="#000" />
          </button>
          <Modal.Title className="mb-0">Qr Code Pix</Modal.Title>
        </Modal.Header>
        <Modal.Body className="d-flex flex-column align-items-center justify-content-center">
          <QRCode
            value={orderSelected.qrCode}
            removeQrCodeBehindLogo
            logoImage={logoQrcode}
            logoPadding={5}
            size={250}
            ecLevel="L"
          />
        </Modal.Body>
        <Modal.Footer className="d-flex align-items-center justify-content-center">
          <button
            type="button"
            className="copy-btn border-0 py-2 px-4 text-center mt-3"
            onClick={handleClickCopyPix}
          >
            Copiar código pix
          </button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
};

export default Ticket;
